import ContactHeader from './components/header'
import ContactForm from './components/contact-form'
import Informations from './components/informations'
import { Helmet } from 'react-helmet'

export default function Contact() {

    return (
        <>
            <Helmet><title>Pixad - Contact</title></Helmet>
            <ContactHeader />

            <div className="contact-content">
                <ContactForm />
                <Informations />
            </div>
        </>
    )
}